"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._delete = exports.put = exports.post = exports.get = exports.wrap = exports.errorByStatus = void 0;
var error_1 = require("../../domain/model/error");
function errorByStatus(status) {
    switch (status) {
        case 400: return error_1.ErrorTypes.INVALID_ARGS;
        case 401: return error_1.ErrorTypes.LOGIN_REQUIRED;
        case 403: return error_1.ErrorTypes.FORBIDDEN;
        case 404: return error_1.ErrorTypes.NO_DATA;
        case 412: return error_1.ErrorTypes.INVALID_ARGS;
        case 500: return error_1.ErrorTypes.INTERNAL;
        default: return error_1.ErrorTypes.UNKNOWN;
    }
}
exports.errorByStatus = errorByStatus;
function wrap(f) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var e_1, er;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, f()];
                case 1: return [2 /*return*/, _c.sent()];
                case 2:
                    e_1 = _c.sent();
                    er = e_1.response ? e_1 : null;
                    /* If not, throw unknown error */
                    if (er == null) {
                        throw new error_1.default(error_1.ErrorTypes.UNKNOWN, e_1);
                    }
                    /* Throw a formatted error */
                    throw new error_1.default(errorByStatus((_a = er.response) === null || _a === void 0 ? void 0 : _a.status), e_1, er.message, (_b = er.response) === null || _b === void 0 ? void 0 : _b.status);
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.wrap = wrap;
/* eslint-disable @typescript-eslint/no-explicit-any */
var get = function (http, url, config) { return wrap(function () {
    return http.get(url, config);
}); };
exports.get = get;
var post = function (http, url, data, config, urlAppend) { return wrap(function () {
    return http.post(urlAppend ? url + urlAppend : url, data, config);
}); };
exports.post = post;
var put = function (http, url, data, config, urlAppend) { return wrap(function () {
    return http.put(urlAppend ? url + urlAppend : url, data, config);
}); };
exports.put = put;
var _delete = function (http, url, data, config, urlAppend) { return wrap(function () {
    return http.delete(urlAppend ? url + urlAppend : url, __assign({ data: data }, config));
}); };
exports._delete = _delete;
